import { render } from "./SingleSkill.vue?vue&type=template&id=326a1bcc&scoped=true"
import script from "./SingleSkill.vue?vue&type=script&lang=js"
export * from "./SingleSkill.vue?vue&type=script&lang=js"

import "./SingleSkill.vue?vue&type=style&index=0&id=326a1bcc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-326a1bcc"]])

export default __exports__